import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from './components/Layout/Layout';
import PartnerLayout from './components/Layout/PartnerLayout';
import ClientLayout from './components/Layout/ClientLayout';

// Client
import LoginClient        from './pages/client/LoginClient';
import RegisterClient     from './pages/client/RegisterClient';
import DashboardClient    from './pages/client/DashboardClient';
import BuyPointsClient    from './pages/client/BuyPointsClient';
import TransactionsClient from './pages/client/TransactionsClient';
import ServicesClient     from './pages/client/ServicesClient';  // ← NOUVEAU
import SettingsClient     from './pages/client/SettingsClient';

// Partenaire
import LoginPartner         from './pages/partner/LoginPartner';
import RegisterPartner      from './pages/partner/RegisterPartner';
import DashboardPartner     from './pages/partner/DashboardPartner';
import ServicesPartner      from './pages/partner/ServicesPartner';
import SalesPartner         from './pages/partner/SalesPartner';
import SettingsPartner      from './pages/partner/SettingsPartner';
import WalletPartner        from './pages/partner/WalletPartner';
import B2CPacksPartner      from './pages/partner/B2CPacksPartner';
import PurchasePacksPartner from './pages/partner/PurchasePacksPartner';
import ApiPartner           from './pages/partner/ApiPartner';
import FacturationPartner   from './pages/partner/FacturationPartner';

// Admin
import LoginAdmin          from './pages/admin/LoginAdmin';
import DashboardAdmin      from './pages/admin/DashboardAdmin';
import PartenairesAdmin    from './pages/admin/PartenairesAdmin';
import ClientsAdmin        from './pages/admin/ClientsAdmin';
import PacksB2BAdmin       from './pages/admin/PacksB2BAdmin';
import TransactionsAdmin   from './pages/admin/TransactionsAdmin';
import DevisesAdmin        from './pages/admin/DevisesAdmin';
import SecuriteAdmin       from './pages/admin/SecuriteAdmin';
import FacturesAdmin       from './pages/admin/FacturesAdmin';
import AdminLayout         from './components/Layout/AdminLayout';

import Home        from './pages/Home';
import PageLoader  from './components/common/PageLoader';
import ToastProvider from './components/common/Toast';
import { NotificationAlertProvider } from './context/NotificationAlertContext';
import './App.css';

// ✅ Vérifie token + type client
const PrivateClientRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user  = JSON.parse(localStorage.getItem('user') || '{}');
  if (!token) return <Navigate to="/login/client" replace />;
  if (user.type && user.type !== 'client') return <Navigate to="/login/client" replace />;
  return children;
};

// Vérifie token partenaire
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user  = JSON.parse(localStorage.getItem('user') || '{}');
  if (!token) return <Navigate to="/login/partner" replace />;
  if (user.type && user.type !== 'partner') return <Navigate to="/login/partner" replace />;
  return children;
};

// Vérifie token admin
const PrivateAdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user  = JSON.parse(localStorage.getItem('user') || '{}');
  if (!token || user.type !== 'admin') return <Navigate to="/login/admin" replace />;
  return children;
};

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);
  if (loading) return <PageLoader />;

  return (
    <NotificationAlertProvider>
    <ToastProvider>
    <BrowserRouter>
      <Routes>

        {/* ── Publiques ── */}
        <Route element={<Layout />}>
          <Route path="/"                 element={<Home />} />
          <Route path="/login/client"     element={<LoginClient />} />
          <Route path="/register/client"  element={<RegisterClient />} />
          <Route path="/login/partner"    element={<LoginPartner />} />
          <Route path="/register/partner" element={<RegisterPartner />} />
          <Route path="/login/admin"      element={<LoginAdmin />} />
        </Route>
        <Route path="/login" element={<Navigate to="/login/partner" replace />} />

        {/* ══ ESPACE CLIENT ══ */}
        <Route path="/dashboard/client" element={
          <PrivateClientRoute><ClientLayout><DashboardClient /></ClientLayout></PrivateClientRoute>
        }/>
        <Route path="/dashboard/client/services" element={
          <PrivateClientRoute><ClientLayout><ServicesClient /></ClientLayout></PrivateClientRoute>
        }/>
        <Route path="/dashboard/client/buy" element={
          <PrivateClientRoute><ClientLayout><BuyPointsClient /></ClientLayout></PrivateClientRoute>
        }/>
        <Route path="/dashboard/client/transactions" element={
          <PrivateClientRoute><ClientLayout><TransactionsClient /></ClientLayout></PrivateClientRoute>
        }/>
        <Route path="/dashboard/client/settings" element={
          <PrivateClientRoute><ClientLayout><SettingsClient /></ClientLayout></PrivateClientRoute>
        }/>

        {/* ══ ESPACE PARTENAIRE ══ */}
        <Route path="/dashboard/partner" element={
          <PrivateRoute><PartnerLayout><DashboardPartner /></PartnerLayout></PrivateRoute>
        }/>
        <Route path="/dashboard/partner/services" element={
          <PrivateRoute><PartnerLayout><ServicesPartner /></PartnerLayout></PrivateRoute>
        }/>
        <Route path="/dashboard/partner/b2c-packs" element={
          <PrivateRoute><PartnerLayout><B2CPacksPartner /></PartnerLayout></PrivateRoute>
        }/>
        <Route path="/dashboard/partner/purchase-packs" element={
          <PrivateRoute><PartnerLayout><PurchasePacksPartner /></PartnerLayout></PrivateRoute>
        }/>
        <Route path="/dashboard/partner/wallet" element={
          <PrivateRoute><PartnerLayout><WalletPartner /></PartnerLayout></PrivateRoute>
        }/>
        <Route path="/dashboard/partner/sales" element={
          <PrivateRoute><PartnerLayout><SalesPartner /></PartnerLayout></PrivateRoute>
        }/>
        <Route path="/dashboard/partner/api" element={
          <PrivateRoute><PartnerLayout><ApiPartner /></PartnerLayout></PrivateRoute>
        }/>
        <Route path="/dashboard/partner/settings" element={
          <PrivateRoute><PartnerLayout><SettingsPartner /></PartnerLayout></PrivateRoute>
        }/>
        <Route path="/dashboard/partner/billing" element={
          <PrivateRoute><PartnerLayout><FacturationPartner /></PartnerLayout></PrivateRoute>
        }/>

        {/* ══ ADMIN ══ */}
        <Route path="/dashboard/admin" element={
          <PrivateAdminRoute><AdminLayout><DashboardAdmin /></AdminLayout></PrivateAdminRoute>
        }/>
        <Route path="/dashboard/admin/partners" element={
          <PrivateAdminRoute><AdminLayout><PartenairesAdmin /></AdminLayout></PrivateAdminRoute>
        }/>
        <Route path="/dashboard/admin/clients" element={
          <PrivateAdminRoute><AdminLayout><ClientsAdmin /></AdminLayout></PrivateAdminRoute>
        }/>
        <Route path="/dashboard/admin/packs" element={
          <PrivateAdminRoute><AdminLayout><PacksB2BAdmin /></AdminLayout></PrivateAdminRoute>
        }/>
        <Route path="/dashboard/admin/transactions" element={
          <PrivateAdminRoute><AdminLayout><TransactionsAdmin /></AdminLayout></PrivateAdminRoute>
        }/>
        <Route path="/dashboard/admin/currencies" element={
          <PrivateAdminRoute><AdminLayout><DevisesAdmin /></AdminLayout></PrivateAdminRoute>
        }/>
        <Route path="/dashboard/admin/security" element={
          <PrivateAdminRoute><AdminLayout><SecuriteAdmin /></AdminLayout></PrivateAdminRoute>
        }/>
        <Route path="/dashboard/admin/invoices" element={
          <PrivateAdminRoute><AdminLayout><FacturesAdmin /></AdminLayout></PrivateAdminRoute>
        }/>

        <Route path="*" element={<Navigate to="/login/partner" replace />} />
      </Routes>
    </BrowserRouter>
    </ToastProvider>
    </NotificationAlertProvider>
  );
}

export default App;